export const CaspianSea = [
  {
    'type': 'FeatureCollection',
    'features': [
      {
        'type': 'Feature', // grey space, disputed (AKSAI CHIN)
        'properties': {'id': 'CS'}, // Caspian Sea
        'geometry': {
          'type': 'Polygon',
          'coordinates': [
            [
              [53.982635146166089, 38.898597372216713],
              [53.557207278796938, 36.795908257366662],
              [50.964722024414513, 36.795115346864819],
              [49.004869843496685, 37.858027179508184],
              [49.295937582530662, 39.480672663723809],
              [49.938099994305524, 40.281100022360881],
              [47.541751851703722, 43.175339315881153],
              [48.1114860731184, 45.832021205926374],
              [50.930674236525832, 47.007581521722848],
              [53.071788369381736, 46.98969378969376],
              [52.700549211371658, 45.561402997065926],
              [51.220809898430666, 45.080969388098787],
              [50.99702170345288, 44.151010646079023],
              [52.131008805137483, 41.823052722277616],
              [53.256674941058307, 41.850537550019915],
              [54.789801031723208, 41.85631068001495],
              [54.541841051868531, 40.968664213421775],
              [53.410445755958115, 40.965019194532935],
              [52.887392013181461, 40.877153820696194],
              [53.180474644602079, 39.288899061243541],
              [53.982635146166089, 38.898597372216713]
            ]
          ]
        },
        'id': 'CS',
        'properties': {
          'fill': '#ffffff', // white fill color
          'fill-opacity': 1, // fully opaque
          'stroke': 'none', // no stroke
          'pointer-events': 'none' // make unclickable
        }
      }
    ]
  }
];

// export const CaspianSea =
// [
//   {'type': 'FeatureCollection',
//  'features': [
//    {'type': 'Feature', // grey space, disputed (AKSAI CHIN)
//    'properties': {'id': 'CS'}, // Caspian Sea
//    'geometry': {'type': 'Polygon',
//     'coordinates': [[
//       [53.982635146166089, 38.898597372216713],
//         [53.557207278796938, 36.795908257366662],
//         [50.964722024414513, 36.795115346864819],
//         [49.004869843496685, 37.858027179508184],
//         [49.295937582530662, 39.480672663723809],
//         [49.938099994305524, 40.281100022360881],
//         [47.541751851703722, 43.175339315881153],
//         [48.1114860731184, 45.832021205926374],
//         [50.930674236525832, 47.007581521722848],
//         [53.071788369381736, 46.98969378969376],
//         [52.700549211371658, 45.561402997065926],
//         [51.220809898430666, 45.080969388098787],
//         [50.99702170345288, 44.151010646079023],
//         [52.131008805137483, 41.823052722277616],
//         [53.256674941058307, 41.850537550019915],
//         [54.789801031723208, 41.85631068001495],
//         [54.541841051868531, 40.968664213421775],
//         [53.410445755958115, 40.965019194532935],
//         [52.887392013181461, 40.877153820696194],
//         [53.180474644602079, 39.288899061243541],
//         [53.982635146166089, 38.898597372216713]
//     ]]},
//    'id': 'CS'}]}
// ]